/**
 * Полифил необходим для поддержки модуля https://github.com/wwayne/react-tooltip
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
 */
export default function () {
  if (!Element.prototype.matches) {
    Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        function (s) {
          const matches = (this.document || this.ownerDocument).querySelectorAll(s);
          let i = matches.length;

          while (--i >= 0 && matches.item(i) !== this) {}
          return i > -1;
        };
  }
}



// WEBPACK FOOTER //
// ./src/utils/matchesPolyfill.js